import { createCompoundComponent } from '../../utilities/createCompoundComponent'

import { Skeleton as BaseSkeleton } from './Skeleton'
import { Block } from './Block'

export const Skeleton = createCompoundComponent(BaseSkeleton, { Block })
